import React, { useEffect } from 'react';
import { Grid, Divider, Button, TextField, Typography} from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { firestore, functions } from '../../../../firebase/firebase'
import encodeQR from '@paulmillr/qr';
import GetAppIcon from '@material-ui/icons/GetApp';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import _ from 'lodash';
import LoadingSpinner from "../../../../Public/components/LoadingSpinner/LoadingSpinner";
import AreYouSure from '../../UI/AreYouSure.js/AreYouSure';
import { useAuth } from '../../../../providers/AuthContext';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

const MobileAuthTab = (props) => {
    const setUp = props.userData?.totp?.enabled
    const verified = props.userData?.totp?.verified
    const [loading, setLoading] = React.useState(false);
    const validateCode = functions.httpsCallable('validateTotpCode');
    const createTotp = functions.httpsCallable('createTotp');
    const [code, setCode] = React.useState('');

    const {userInfo} = useAuth();

    const [regenOpen, setRegenOpen] = React.useState(false);
    const [resetOpen, setResetOpen] = React.useState(false);

    const isSuper = userInfo.super;

    useEffect(() => {
        async function fetchTotp() {
            if(props.userData?.totp?.auth_url === '' || _.isUndefined(props.userData?.totp?.auth_url)){
                setLoading(true);
                await createTotp({
                    userData: props.userData, 
                    userEmail: props.userData.email
                }).then((result) => {
                    if(result.data.success){
                        firestore.collection('users').doc(props.userData.docId).update({totp: {...props.userData.totp, auth_url: result.data.auth_url}, totpObj: result.data.totpObj }).then(() => {
                            props.setUserData({...props.userData, totpObj: result.data.totpObj, totp: {...props.userData.totp, auth_url: result.data.auth_url}})
                            setLoading(false)
                        }).catch((error) => {
                            console.error(error)
                            setLoading(false)
                        })
                    } else {
                        setLoading(false)
                    }
                }).catch((error) => {
                    console.error(error)
                    setLoading(false)
                })
            }
        }
        fetchTotp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

        if(code.length === 6){
            setLoading(true)
            validateCode({totp: props.userData.totpObj, code: code, url: props.userData.totp.auth_url}).then(async (result) => {
                if(result.data.success){
                    let codes = await generateRecoveryCodes(10)
                    firestore.collection('users').doc(props.userData.docId).update({totp: {...props.userData.totp, enabled: true, recoveryCodes: codes}}).then(() => {
                        props.setUserData({...props.userData, mfaType: 'MobileAuth', mfaEnabled: true, totp: {...props.userData.totp, enabled: true, recoveryCodes: codes}})
                        setLoading(false)
                        setCode('')
                    }).catch((error) => {
                        console.error(error)
                        setLoading(false)
                        setCode('')
                    })
                } else {
                    return;
                }

            }).catch((error) => {
                console.error(error)
            })
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code]);

    useEffect(() => {

    }, [props.userData]);

    const txt = props.userData?.totp?.auth_url
    const svgElement = encodeQR(txt, 'svg', { scale: 4, }); // SVG vector image element

    const generateRecoveryCodes = (numOfCodes) => {
        let recoveryCodes = [];
        
        for (let i = 0; i < numOfCodes; i++) {
            let firstPart = Math.random().toString(36).substr(2, 5); // 5 characters
            let secondPart = Math.random().toString(36).substr(2, 5); // 4 characters
            
            let code = `${firstPart}-${secondPart}`; // Combine with '-'
            recoveryCodes.push(code);
        }
    
        return recoveryCodes;
    };

    const handleRegenerate = async () => {
        setLoading(true)
        let codes = await generateRecoveryCodes(10)
        firestore.collection('users').doc(props.userData.uid).update({totp: {...props.userData.totp, enabled: true, recoveryCodes: codes}}).then(() => {
            props.setUserData({...props.userData, totp: {...props.userData.totp, enabled: true, recoveryCodes: codes}})
            setLoading(false)
            setCode('')
        }).catch((error) => {
            console.error(error)
            setLoading(false)
            setCode('')
        })
    }

    const handleReset = async () => {
        setLoading(true)
        firestore.collection('users').doc(props.userData.uid).update({mfaType:'Email', totp: {...props.userData.totp, enabled: false, verified: false, recoveryCodes: []}}).then(() => {
            props.setUserData({...props.userData, mfaType:'Email', totp: {...props.userData.totp, enabled: false, verified: false, recoveryCodes: []}})
            setLoading(false)
            setCode('')
        }).catch((error) => {
            console.error(error)
            setLoading(false)
            setCode('')
        })
    }

    let recoveryCodesComponent = null;
    let qrCodeComponent = null;

    if (!setUp && !verified) {
     qrCodeComponent = (<React.Fragment>
    <Grid container item xs={12} justifyContent='center' >
        <Typography variant="body1">To enable Mobile Authentication, scan the QR code below with your Authenticator App.</Typography>
    </Grid>
    <Grid container item xs={12} justifyContent='center' >
        <div
            style={{ width: '200px', height: '200px', overflow: 'hidden', }}
            dangerouslySetInnerHTML={{ __html: svgElement }}
        />
    </Grid>
    <Grid item xs={12} >
        <Divider style={{margin:'10px'}}/>
    </Grid>
    <Grid container item xs={12} justifyContent='center' >
        <Typography variant="body1">Then enter the code here.</Typography>
    </Grid>
    <Grid container item xs={12} justifyContent='center' >
        <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="code"
            label="Code"
            disabled={loading}
            type="text"
            id="code"
            value={code}
            InputProps={{
                endAdornment: (
                    <React.Fragment>
                        {loading ? <LoadingSpinner/> : null}
                    </React.Fragment>
                ),
            }}
            onChange={(e) => {setCode(e.target.value);
                
            }}
        />
    </Grid>
    </React.Fragment>)
    }

    if (!_.isUndefined(props.userData.totp.recoveryCodes)) {
        recoveryCodesComponent = 
        (<React.Fragment>
        <Grid container item xs={6} justifyContent='center' >
            <Button
                variant="contained"
                color="primary"
                startIcon={<RotateLeftIcon />}
                onClick={() => {
                   setRegenOpen(true)
                }}
            >Regenerate</Button>
        </Grid>
        <Grid container item xs={6} justifyContent='center' >
            {isSuper&&
            <Button
                variant="contained"
                startIcon={<DeleteForeverIcon />}
                color="primary"
                onClick={() => {
                    setResetOpen(true)
                }}
            >Reset User Auth</Button>}
        </Grid>
        <Grid container item xs={12} justifyContent='center' >
            <Typography variant="body1">Recovery Codes</Typography>
        </Grid>
        <Grid container item xs={4} justifyContent='center' ></Grid>
        <Grid container item xs={4} justifyContent='center' >
            {props.userData?.totp?.recoveryCodes.map((code, index) => {
                return (
                    <Grid container item xs={6} key={index}justifyContent='center'>
                        <Typography variant="body1"><b>{code}</b></Typography>
                    </Grid>
                )
            })}
        </Grid>
        <Grid container item xs={4} justifyContent='center' ></Grid>
        <Grid item xs={12} >
            <Divider style={{margin:'10px'}}/>
        </Grid>
        <Grid container item xs={12} justifyContent='center' >
            <Typography variant="body1">Keep these codes in a safe place. You will need them if you lose access to your Authenticator App.</Typography>
        </Grid>
        <Grid container item xs={6} justifyContent='center' >
            <Button
                variant="contained"
                color="primary"
                startIcon={<GetAppIcon />}
                onClick={() => {
                    const element = document.createElement("a");
                    const file = new Blob([props.userData.totp?.recoveryCodes.join('\n')], {type: 'text/plain'});
                    element.href = URL.createObjectURL(file);
                    element.download = "RecoveryCodes.txt";
                    document.body.appendChild(element); // Required for this to work in FireFox
                    element.click();
                }}
            >Download</Button>
        </Grid>
        <Grid container item xs={6} justifyContent='center' >
            <Button
                variant="contained"
                startIcon={<FileCopyIcon />}
                color="primary"
                onClick={() => {
                    navigator.clipboard.writeText(props.userData.totp?.recoveryCodes.join('\n'));
                }}
            >Copy</Button>
        </Grid>
    </React.Fragment>)
    }
        
    return (
        <Grid container spacing={2}>
            <AreYouSure timer={10} customMessage={`Are you sure you want to reset this user's authentication? This will disable their current authentication and recovery codes.`} open={resetOpen} setOpen={setResetOpen} passedFunction={() => handleReset()}/>
            <AreYouSure timer={10} customMessage={`Are you sure you want to regenerate your recovery codes? This will generate a brand new set rendering your current ones void.`} open={regenOpen} setOpen={setRegenOpen} passedFunction={() => handleRegenerate()}/>
            <Grid item xs={12} >
                <Typography variant="h6">Mobile Authentication</Typography>
            </Grid>
            <Grid item xs={12} >
                <Divider style={{marginBottom:'10px'}}/>
            </Grid>
            {!setUp && !verified && qrCodeComponent}
            {setUp && recoveryCodesComponent}
        </Grid>      
    )
}

export default withRouter(MobileAuthTab)